import {needAuth} from "../instance/Instance";

async function getMemoList(search, pageable) {
    console.log(">> 메모관리 조회")

    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {
            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;

    try{
        return  await needAuth.post('/memo?'+pageStr, search);
    }catch (error){
        return error;
    }
}

async function removeMemos(ids) {
    return await needAuth.put('/memo/delete', ids);
}

async function saveMemo(data) {
    return await needAuth.post(`/memo/create`, data);
}

async function updateMemo(memo) {
    const data = {id: memo.id, fieldName : "content", value : memo.content}
    return await needAuth.put(`/memo`, data);
}

export {getMemoList, saveMemo, updateMemo, removeMemos}